import React from 'react';
import _ from 'lodash';
import { GetRegion } from 'constants.js';
import { useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { getPurchaseNodeId } from 'services/api/payway/purchaseNodeId';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetUrlParams } from 'hooks/useGetUrlParams';

export const useCheckoutRedirect = () => {
  const navigate = useNavigate();
  const { paramsFromUrl, location } = useGetUrlParams();

  const anonymousUser =
    location?.state?.anonymousUserComeFromPlayer ||
    paramsFromUrl.get('anonymousUser') === 'true';
  const isActiveClaroAds = useSelector(
    selectMetadataKeyByRegion('cv_advertising_config'),
  );
  const isBuyOrRent =
    location?.state?.isBuyOrRentContent ||
    paramsFromUrl.get('isBuyRentContent') === 'true';

  const freemiumUserTryToPBuy =
    isActiveClaroAds?.enable && anonymousUser && !isBuyOrRent;

  const handleFreemiumRedirect = async nodesNav => {
    const paramsNodeId = {
      url: `/services/payway/paymentservice/v1/purchasednodeid/`,
      hasClaroAdActive: isActiveClaroAds,
    };
    try {
      const result = await getPurchaseNodeId(paramsNodeId);

      if (result?.response?.data.errors.length > 0)
        throw result?.response?.data.errors;
      const nodeId = result?.data?.node_id;
      sessionStorage.setItem('nodeIdSaved', nodeId);
      // const findNode = await findNodeTarget(nodesNav, nodeId);
      // const code = findNode?.code || nodesNav?.[0]?.code || 'homeuser';
    } catch (error) {
      return navigate(`/${GetRegion()}/payment${location.search}`);
    }
  };
  const handleRedirectCheckoutFromFreemium = async nodesNav => {
    if (freemiumUserTryToPBuy) return handleFreemiumRedirect(nodesNav);
    navigate(`/${GetRegion()}/payment${window.location.search}`);
  };

  return {
    handleRedirectCheckoutFromFreemium,
  };
};
